import { Stack } from '@mui/material';
import { IsolationSpecificity } from '@silbo/core';
import SpecificityChip from '../../bed-management/components/SpecificityChip';

type IsolationSpecificitiesProps = {
  specificities: IsolationSpecificity[];
};

const IsolationSpecificities = ({ specificities }: IsolationSpecificitiesProps) => (
  <Stack direction="row" flexWrap="wrap" justifyContent="flex-end" gap="6px">
    {specificities.map((specificity) => (
      <SpecificityChip
        key={typeof specificity === 'string' ? specificity : specificity.name}
        specificity={specificity}
      />
    ))}
  </Stack>
);

export default IsolationSpecificities;
